"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationIdentity',
  data: function data() {
    return {
      loading: false,
      identities: []
    };
  },
  created: function created() {
    var _this = this;
    this.loading = true;
    (0, _decoration.decorationIdentityApi)().then(function (data) {
      _this.identities = data && data.identities || [];
    }).finally(function () {
      _this.loading = false;
    });
  }
};